import { render } from "./AdminDriverDetailList.vue?vue&type=template&id=1d27e354&scoped=true&ts=true&lang=true"
import script from "./AdminDriverDetailList.vue?vue&type=script&lang=ts"
export * from "./AdminDriverDetailList.vue?vue&type=script&lang=ts"

import "./AdminDriverDetailList.vue?vue&type=style&index=0&id=1d27e354&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d27e354"]])

export default __exports__